var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuotationMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#84BA90",
  d: "M8.88 21.64H0v-8.88q0-2.4.48-4.48.56-2.16 1.6-3.76a8.6 8.6 0 0 1 2.8-2.56Q6.56 1 8.8 1v4q-1.36 0-2.24.72-.88.64-1.44 1.76t-.8 2.56a23 23 0 0 0-.16 2.72h4.72zm14.64 0h-8.88v-8.88q0-2.4.48-4.48.56-2.16 1.6-3.76a8.6 8.6 0 0 1 2.8-2.56Q21.2 1 23.44 1v4q-1.36 0-2.24.72-.88.64-1.44 1.76t-.8 2.56q-.16 1.36-.16 2.72h4.72z"
})));
export default SvgQuotationMark;